/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, October 20th 2021, 8:40:49 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { PrimaryKeyValue } from "lib/types";
import { Organization, User } from "lib/schemas";
import { WritableModel } from "lib/schemas/abstract";
import { schemaBuilder } from "lib/validation";

export interface Department extends WritableModel<true> {
  name: string;
  organization: PrimaryKeyValue<Organization>;
  sequence: number;
  workers: PrimaryKeyValue<User>[];
}

export const DepartmentValidationSchema: schemaBuilder.SchemaOf<Department> = schemaBuilder.object().shape({
  id: schemaBuilder.string().uuid().nullable(),
  name: schemaBuilder.string().required("Department Name is required."),
  organization: schemaBuilder.string().uuid().nullable(),
  sequence: schemaBuilder.number().nullable(),
  workers: schemaBuilder.array().nullable().optional(),
});

export const newDepartmentDefault: Department = {
  name: "",
  organization: null,
  sequence: 0,
  workers: [],
};
